import axiosApiClient from "../axios";

const PATH = '/api/cctvconfig'

export const getAllCCTVConfigs = async () => {
    return await axiosApiClient.get(PATH);
};

export const getAllCCTVConfigByBranchId = async branchId => {
    return await axiosApiClient.get(`${PATH}/${branchId}/branch`);
};

export const getAllCCTVConfigById = async (id) => {
    return await axiosApiClient.get(`${PATH}/${id}`);
};

export const addCCTVConfig = async (user) => {
    try {
        return await axiosApiClient.post(PATH, user, {});
    } catch (err) {
        // Preserve the original error structure so handleApiError can extract the message
        if (err.response?.data?.message) {
            const error = new Error(err.response.data.message);
            error.response = err.response;
            throw error;
        }
        throw err;
    }
};

export const deleteCCTVConfig = async (userId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${userId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete CCTVConfig failed');
    }
};

export const updateCCTVConfig = async (userId, user) => {
    try {
        return await axiosApiClient.put(`${PATH}/${userId}`, user, {});
    } catch (err) {
        // Preserve the original error structure so handleApiError can extract the message
        if (err.response?.data?.message) {
            const error = new Error(err.response.data.message);
            error.response = err.response;
            throw error;
        }
        throw err;
    }
};

